"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCustomerAccountMessage = void 0;
const enums_1 = require("../enums");
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackCustomerAccountMessage() {
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: 'JS_Event',
        eventCategory: 'CustomerAccount',
        eventAction: 'Message',
        eventLabel: enums_1.MessageLabel.PASSWORD_CHANGED_SUCCESSFULLY,
        nonInteraction: true,
    });
}
exports.trackCustomerAccountMessage = trackCustomerAccountMessage;
//# sourceMappingURL=trackCustomerAccountMessage.js.map